import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.less']
})
export class HomeFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}